
<script lang="ts" setup>
import type { IProps } from './solutions-UiAccordeon.types'

defineProps<IProps>()
const activeIndex = ref(0)

function setActive(index: number) {
  activeIndex.value = index
}

</script>

<template>
  <ul class="accordeon__list">
    <li
      v-for="(item, index) in data"
      :key="index"
      :title="`${index+1}`"
      :class="[
        'accordeon__item',
        { 'accordeon__item--active': activeIndex === index }
      ]"
      @click="setActive(index)"
    >
      <h3 class="accordeon__item_title">
        {{ item.title }}
      </h3>

      <transition name="slide">
        <div
          v-if="activeIndex === index"
          class="accordeon__item_text"
        >
          <p>{{ item.text }}</p>
        </div>
      </transition>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.accordeon {

  &__list {
    margin-top: 1.6rem;
    background-color: $white;

    @include atXL {
      margin-top: 8rem;
    }
  }

  &__item {
    position: relative;
    padding: 2.8rem 2.4rem 1.6rem 8.8rem;
    font-weight: 500;
    border-radius: 1.6rem;

    &:before {
      position: absolute;
      top: 1.4rem;
      left: 2.4rem;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      min-width: 4.8rem;
      width: 4.8rem;
      height: 4.8rem;
      color: $text-200;
      font-size: 1.8rem;
      line-height: 3.2rem;
      background-color: $white;
      border: 1px solid $gray-500;
      border-radius: 50%;
      content: attr(title);
    }

    @include atM {
      padding: 3.4rem 13.8rem 4rem 11.2rem;

      &:before {
        position: absolute;
        top: 3rem;
        left: 4rem;
      }
    }

    &--active {
      border: 1px solid $gray-300;

      &:before {
        color: $white;
        background-color: $purple-400;
        border: 1px solid $purple-400;
      }

      &:after {
        position: absolute;
        top: -0.1rem;
        left: 2.4rem;
        display: inline-block;
        width: 9.4rem;
        height: 0.2rem;
        background-color: $purple-400;
        content: '';
      }

      @include atM {
        &:after {
          left: 4rem;
          width: 20.3rem;
        }
      }
    }

    &_title {
      font-size: 2rem;
      line-height: 2.4rem;

      @include atXL {
        font-size: 2.8rem;
        line-height: 3.6rem;
      }
    }

    &_text {
      margin-top: 0.8rem;
      color: $text-300;
      font-size: 1.6rem;
      line-height: 2.4rem;

      @include atXL {
        margin-top: 1.2rem;
        font-size: 1.8rem;
      }
    }
  }
}
</style>
